const DEV = process.env.NODE_ENV === 'development';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('init about');
		ScrollTrigger.matchMedia({
			"(min-width: 901px)": function() {
				ScrollTrigger.create({
					trigger: '.aboutContainer',
					start: 'top top',
					end: 'bottom bottom',
					pin: '#aboutContact',
					scrub: true,
				});
			}
		});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		console.log('finalize common');
	},
};
